<template>
  <v-navigation-drawer
    width="550px"
    absolute
    persistent
  >
    <template v-slot:prepend>
      <ThemedTapBar
        v-model="currentTabModel"
        :tabs="items"
      />
    </template>
    <div class="drawer-content">
      <v-tabs-items v-model="currentTabModel">
        <v-tab-item>
          <VoyageCalculationForm />
        </v-tab-item>
        <v-tab-item>
          <PastVoyages />
        </v-tab-item>
        <v-tab-item>
          <Routes />
        </v-tab-item>
        <v-tab-item>
          <CustomAreas />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import VoyageCalculationForm from "./voyage/new/View.vue";
import PastVoyages from "./voyage/list/View.vue";
import Routes from "./route/list/View.vue";
import CustomAreas from "./area/list/View.vue";
import ThemedTapBar from "@/core/ThemedTapBar.vue";

export default {
  name: "WeatherRoutingDrawer",
  components: {
    VoyageCalculationForm,
    PastVoyages,
    Routes,
    CustomAreas,
    ThemedTapBar,
  },
  data: function () {
    return {
      items: ["Create Voyage", "Voyages", "Routes", "Areas"],
    };
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["currentTab"]),
    currentTabModel: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_CURRENT_TAB", value, {
          root: true,
        });
      },
    },
  },
};
</script>

<style scoped>
.drawer-content {
  display: flex;
  flex-direction: column;
  height: 100%; /* Occupy all available space in the drawer */
  overflow: hidden; /* Prevent the drawer from scrolling */
}
</style>
